// /TBS/frontend/src/components/EnvSelector.jsx

import React, { useState, useEffect } from 'react';
import API from '../helpers/API';   // uses existing axios instance with proper baseURL

const EnvSelector = () => {
  const [selector, setSelector] = useState(null);   // 'local' | 'production' | null
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  // Fetch current state on mount
  useEffect(() => {
    API.get('/api/env')
      .then(res => {
        if (res.data.selector) {
          setSelector(res.data.selector);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch env state', err);
        setLoading(false);
      });
  }, []);

  const handleToggle = async (newSelector) => {
    if (newSelector === selector) return;  // no change

    try {
      setMessage('');
      const res = await API.post('/api/env', {
        selector: newSelector,
        persist: true
      });
      setSelector(newSelector);
      setMessage(res.data.message || `Switched to ${newSelector}`);
      // Clear message after 4 seconds
      setTimeout(() => setMessage(''), 4000);
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Failed to toggle environment';
      setMessage(`❌ ${errMsg}`);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  if (loading) return null;   // silent while loading

  // Simple segmented control styled inline
  const activeStyle = {
    background: '#3b82f6',
    color: 'white',
    border: '1px solid #3b82f6',
    padding: '0.4rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginRight: '4px'
  };
  const inactiveStyle = {
    background: 'white',
    color: '#3b82f6',
    border: '1px solid #3b82f6',
    padding: '0.4rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer',
    marginRight: '4px'
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '8px 16px' }}>
      <span style={{ fontWeight: '600', color: '#333' }}>Environment:</span>
      <button
        style={selector === 'local' ? activeStyle : inactiveStyle}
        onClick={() => handleToggle('local')}
        title="Switch to Local (Development)"
      >
        Local
      </button>
      <button
        style={selector === 'production' ? activeStyle : inactiveStyle}
        onClick={() => handleToggle('production')}
        title="Switch to Production"
      >
        Production
      </button>
      {message && (
        <span style={{ fontSize: '0.85rem', color: message.startsWith('❌') ? '#dc2626' : '#16a34a', maxWidth: '300px' }}>
          {message}
        </span>
      )}
    </div>
  );
};

export default EnvSelector;